/** @format */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/icons/Menu';
import Clear from '@material-ui/icons/Clear';
import AccountCircle from '@material-ui/icons/AccountCircle';
import HelpOutline from '@material-ui/icons/HelpOutline';
import Drawer from '@material-ui/core/Drawer';
import intl from 'react-intl-universal';

import GlobalMenuList from './GlobalMenuList';
import GlobalMenuItem from './GlobalMenuItem';
import GlobalMenuIcon from './GlobalMenuIcon';
import GlobalMenuGroup from './GlobalMenuGroupContainer';
import {
  PREREGISTER_APPLICANTS_URL,
  CASES_URL,
  SERVICEINIT_URL,
  DASHBOARD_URL,
  DOCUMENTS_URL,
  UPLOADS,
  HELP_URL,
  LOGOUT_URL,
  USERS_URL,
  ENGAGEMENTS_URL,
  ENGAGEMENT_GROUP_URL,
  IDVALIDATOR_URL,
  MANUALREQUESTQUEUE_URL,
  APP_UPDATE_URL,
  CASE_UPLOAD_URL,
  PROFORMA_UPLOAD,
  POWERBI_URL,
  LOBBY_MESSAGE_URL,
  PAYWALLREQUESTQUEUE_URL,
  TEAM_CASES_URL,
  OVERVIEW_CASES_URL,
  TAXCHAT_SERVICE_INITIATION_URL,
} from 'src/constants/constants.js';
import { isTaxChatSuperAdmin  } from 'src/helpers';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    backgroundColor: theme.colors.eyConfidentGrey,
  }
});

const GlobalMenuPres = ({
  isMenuOpen,
  toggleDrawer,
  countInboxUnread,
  isApplicant,
  isCorpClient,
  isEYPro,
  isEYAdmin,
  isCorporateClientLineManagerSelector,
  isDeleteProfile,
  classes
}) => {
  const accessAllowed = (isEYPro || isEYAdmin || isDeleteProfile || isTaxChatSuperAdmin());
  return (
    <Fragment>
      <div className="header-button menu">
        <Menu className="icon lg" onClick={toggleDrawer(true)} />
      </div>
      <Drawer classes={{ paper: classes.root}} anchor="right" open={isMenuOpen} onClose={toggleDrawer(false)}>
        <div tabIndex={0} role="button" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)} className="global-menu-container">
          <div className="icon-menu nav-bar">
            {/* <GlobalMenuIcon route={'/'} text={intl.get('globalMenu.myProfile')}> */}
            <span className="link-icon anchor-cursor">
              <AccountCircle className="icon lg" />
              <label className="icon-label">{intl.get('globalMenu.myProfile')}</label>
            </span>
            {/* </GlobalMenuIcon> */}
            <GlobalMenuIcon route={HELP_URL} text={intl.get('globalMenu.help')}>
              <HelpOutline className="icon lg" />
            </GlobalMenuIcon>
            <GlobalMenuIcon route={LOGOUT_URL} text={intl.get('globalMenu.logout')} className="logout">
              <div className="mdi mdi-logout-variant icon lg" />
            </GlobalMenuIcon>
          </div>
          <div className="text-menu">
            <nav className="nav-bar">
              <Clear className="icon lg" onClick={toggleDrawer(false)} />
            </nav>
            <GlobalMenuList>
              <React.Fragment>
                <GlobalMenuItem route={DASHBOARD_URL} text={intl.get('globalMenu.dashboard')} />
                {!isApplicant && <GlobalMenuItem route={CASES_URL}  text={intl.get('globalMenu.myCases')} />}
                {!isApplicant && <GlobalMenuItem route={TEAM_CASES_URL}  text={intl.get('globalMenu.teamCases')} />}
                {!isApplicant && <GlobalMenuItem route={OVERVIEW_CASES_URL}  text={intl.get('globalMenu.overviewCases')} />}
                {!isApplicant && <GlobalMenuItem route={TAXCHAT_SERVICE_INITIATION_URL} text={intl.get('globalMenu.serviceInitiation')} />}
                {/* {!isApplicant ||
                  (!isCorporateClientLineManagerSelector && (
                    <GlobalMenuItem route={SERVICEINIT_URL} text={intl.get('globalMenu.serviceInitiation')} />
                  ))} */}
                <GlobalMenuItem route={DOCUMENTS_URL} text={intl.get('globalMenu.documents')} />
                <GlobalMenuItem route={POWERBI_URL} text={intl.get('globalMenu.powerbi')} />
                {isDeleteProfile &&
                <GlobalMenuItem route={LOBBY_MESSAGE_URL} text={intl.get('globalMenu.lobbyMessage')} />}
                {(isEYAdmin || isEYPro || isDeleteProfile || isTaxChatSuperAdmin()) && (
                  <GlobalMenuGroup text={intl.get('globalMenu.administration')}>
                    {isEYAdmin && <GlobalMenuItem route={USERS_URL} text={intl.get('globalMenu.users')} />}
                    {(isDeleteProfile || isTaxChatSuperAdmin()) && <GlobalMenuItem route={ENGAGEMENT_GROUP_URL} text={intl.get('globalMenu.engagementGroup')} />}
                    <GlobalMenuItem route={ENGAGEMENTS_URL} text={intl.get('globalMenu.engagements')} />
                    {isDeleteProfile && <GlobalMenuItem route={UPLOADS} text={intl.get('globalMenu.cmsUploads')} />}
                    {accessAllowed && <GlobalMenuItem route={PREREGISTER_APPLICANTS_URL} text={intl.get('globalMenu.bulkTemplateUpdates')} />}
                    {false && isEYAdmin && <GlobalMenuItem route={APP_UPDATE_URL} text={intl.get('globalMenu.appUpdate')} />}
                    {isEYAdmin && <GlobalMenuItem route={CASE_UPLOAD_URL} text={intl.get('globalMenu.caseUpload')} />}
                    {isEYAdmin && <GlobalMenuItem route={PROFORMA_UPLOAD} text={intl.get('globalMenu.proformaUpload')} />}
                    {isEYAdmin && <GlobalMenuItem route={IDVALIDATOR_URL} text={intl.get('globalMenu.idValidator')} />}
                    {isEYAdmin && <GlobalMenuItem route={MANUALREQUESTQUEUE_URL} text={intl.get('globalMenu.manualRequestQueue')} />}
                    {isDeleteProfile && <GlobalMenuItem route={PAYWALLREQUESTQUEUE_URL} text={intl.get('globalMenu.paywallRequestQueue')} />}
                  </GlobalMenuGroup>
                )}
              </React.Fragment>
            </GlobalMenuList>
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
};

GlobalMenuPres.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
};

export default withStyles(styles)(GlobalMenuPres);
